import React from "react";
import ErrorContainer from "../../containers/Error";

function Error() {
  return <ErrorContainer />;
}

export default Error;
